import { Component, ChangeDetectionStrategy } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToasterService } from "@shared/services/toaster.service";
import { AdminIrcApiService } from "@shared/services/admin/admin-irc-api.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { FormsModule } from "@angular/forms";
import { LogService } from "@shared/services/log.service";

export interface AddSelfhostedIrcBridgeDialogContextt {
    isSaving: boolean;
    provisionUrl: string;
}

@Component({
    templateUrl: "./add-selfhosted.component.html",
    styleUrls: ["./add-selfhosted.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, TranslatePipe]
})
export class AdminIrcBridgeAddSelfhostedComponent {

    public isSaving = false;
    public provisionUrl: string;

    constructor(
        public modal: NgbActiveModal,
        private readonly ircApi: AdminIrcApiService,
        private readonly toaster: ToasterService,
        public readonly translate: TranslateService,
        private readonly logService: LogService,
    ) {
        this.translate = translate;
    }

    public add() {
        this.isSaving = true;
        this.ircApi.newSelfhosted(this.provisionUrl).then(() => {
            this.translate.get('IRC Bridge added').subscribe((res: string) => {
                this.toaster.pop("success", res);
            });
            this.modal.close();
        }).catch(err => {
            this.logService.error(err);
            this.isSaving = false;
            this.translate.get('Failed to create IRC bridge').subscribe((res: string) => {
                this.toaster.pop("error", res);
            });
        });
    }
}
